import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '../http/api.service';
import { Holding } from '../models/holding.model';

@Injectable({ providedIn: 'root' })
export class HoldingService {
  private BACKEND_URL: string;
  private HEADERS: any;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {
    this.HEADERS = this.apiService.HEADERS;
    this.BACKEND_URL = this.apiService.BACKEND_URL;
  }

  async getAllHoldingsNoteLinkedWithUser(idUser: string) {
    return await this.http.get<Holding[]>(
      `${this.BACKEND_URL}/v1/holding/get-not-linked-with-user/${idUser}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async getAllHoldingByCompanie(idCompanie: string) {
    return await this.http.get<Holding[]>(
      `${this.BACKEND_URL}/v1/holding/holding-by-company/${idCompanie}`
    ).toPromise();
  }

  async getAllHoldings() {
    return await this.http.get<Holding[]>(
      `${this.BACKEND_URL}/v1/holding`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async getAllHoldingsByUser(idUser: string) {
    return await this.http.get<Holding[]>(
      `${this.BACKEND_URL}/v1/holding/holding-by-user/${idUser}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async addCompanyOnHolding(idHolding: string, idCompany: string) {
    return await this.http.put(
      `${this.BACKEND_URL}/v1/holding/add-company/${idHolding}/${idCompany}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async removeCompanyOnHolding(idHolding: string, idCompany: string) {
    return await this.http.delete(
      `${this.BACKEND_URL}/v1/holding/remove-company/${idHolding}/${idCompany}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async createHolding(object: any) {
    return await this.http.post<any>(
      this.BACKEND_URL + '/v1/holding',
      object,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async updateHolding(idHolding: string, object: any) {
    return await this.http.put<any>(
      `${this.BACKEND_URL}/v1/holding/${idHolding}`,
      object,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async deleteHolding(idHolding: string) {
    return await this.http.delete<any>(
      `${this.BACKEND_URL}/v1/holding/${idHolding}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async getHolding(id: string) {
    const response = await this.getAllHoldings();
    const holding = response.filter(holding => holding.id === id);
    return holding[0];
  }
}
